// Dependencies imports
import React, { useState, useEffect } from "react";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { awsSignIn, authData } from "../../../redux/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { API } from "aws-amplify";
import config from "../../../config/aws-exports";
// Local imports
import { Constants } from "../../../config/Constants";
import CourseRegUsers from "./CourseRegUsers";
import CourseApproval from "./CourseApproval";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
// Style imports
import listTopStyle from "./listTopics.module.scss";
import CoursePublish from "./CoursePublish";
import moment from "moment";
import MarkPopularCourse from "./MarkPopularCourse";
import { Button } from "@mui/material";
import { FileDownload } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import NothiongHereYet from "../../../assets/Nothing Here Yet.gif";

import Tooltip from "@mui/material/Tooltip";

// Custom Toolbard to export and filter for datagrid

// const useStyles = makeStyles({
//   root: {
//     "& .super-app-theme--header": {
//       backgroundColor: Constants.blue_color,
//       fontSize: "16px",
//       color: "rgb(255,255,255)",
//       fontFamily: "nunito",
//     },
//   },
//   modal: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     border: "none",
//     transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
//   },
//   ".MuiDataGrid-root": {
//     fontSize: "14px",
//     fontFamily: "nunito",
//     fontWeight: 400,
//     color: "black",
//     cursor: "pointer",
//   },
// });

const funData = (data) => {
  let datalist = data.map((item) => {
    let obj = {};
    obj.course_id =
      item.course_id != null || item?.course_id !== "null"
        ? item?.course_id
        : "";
    obj.coursename = item?.tn;

    obj.cftype = item?.cftype;
    obj.sub = item?.sub;
    obj.lastmodifiedby = item?.cby;
    obj.contententAdded = item?.nugcnt;
    obj.speakerName = item?.speakerName;
    obj.coursetype = item?.coursetype;
    obj.dur = item?.dur;
    obj.lastmodifiedon = item?.con;
    obj.tags = item?.cgry_taggs ? item?.cgry_taggs.join(",") : "";
    obj.waitinglist = item?.waiting?.waiting_count;
    obj.resgisteredusers = item?.registered?.registered_count;
    return obj;
  });
  return datalist;
};

// const funData1 = (data, catlist) => {
//   let datalist = data.map((item) => {
//     let obj = {};
//     obj.coursename = item?.tn;
//     obj.tdesc = item?.tdesc;

//     const selectedItem = catlist?.find((item1) => item1.id === item?.cgry_id);

//     obj.sub = selectedItem?.name;
//     obj.course_id = item?.tid;
//     let inHoures = secondsToHoursMinutes(item?.dur);

//     obj.duration = `${inHoures?.hours}hours ${inHoures?.minutes}minutes`;

//     obj.priceinr = item?.priceinr;
//     obj.priceusd = item?.priceusd;
//     obj.tobj = item?.tobj;

//     return obj;
//   });
//   return datalist;
// };

// const headers = [
//   { label: "Title", key: "coursename" },
//   { label: "course description", key: "tdesc" },
//   { label: "Subjects", key: "sub" },
//   { label: "Course ID", key: "course_id" },
//   { label: "Length", key: "duration" },
//   { label: "Price in INR", key: "priceinr" },
//   { label: "Price in USD", key: "priceusd" },
//   { label: "No of modules", key: "tobj" },
// ];

// function secondsToHoursMinutes(seconds) {
//   const hours = Math.floor(seconds / 3600);
//   const remainingSeconds = seconds % 3600;
//   const minutes = Math.floor(remainingSeconds / 60);

//   return {
//     hours,
//     minutes,
//     formatted: `${hours} hour${hours !== 1 ? "s" : ""} ${minutes} minute${
//       minutes !== 1 ? "s" : ""
//     }`,
//   };
// }
// Start of main Tenant Component

export default function ListTopics({
  searchText,
  open,
  close,
  listForReg,
  speakerList,
}) {
  //const classes = useStyles();
  const navigate = useNavigate();
  // const [loading, setLoading] = useState(true);
  const [topics, setTopics] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [editopen, setEditOpen] = useState(false);
  const [topicRowData, setTopicRowData] = useState({});
  const [openWait, setOpenWait] = useState(false);
  const [openReg, setOpenReg] = useState(false);
  const [topicId, setTopicId] = useState("");
  const [data, setData] = useState([]);
  //const [data1, setData1] = useState([]);
  const [topicName, setTopicName] = useState("");

  const [spin, setSpin] = useState(false);

  let userDetails = useSelector(authData);
  let tenantoid = false;
  const dispatch = useDispatch();

  useEffect(() => {
    getTopicList();
    getAllTenants();
    breadcrumb();
    getCategories();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function breadcrumb() {
    let sdata = { ...userDetails };
    if (sdata.breadcrumb === undefined) {
      sdata.breadcrumb = [];
      let temp = [...sdata.breadcrumb];
      temp[0] = {
        name: "Courses",
        path: "/uspcontent",
      };
      temp[1] = {
        name: sdata?.categorydata?.name,
        path: "/uspcontent/viewtopic",
      };
      sdata.breadcrumb = temp;
    } else {
      let temp = [...sdata.breadcrumb];
      temp[0] = {
        name: "Courses",
        path: "/uspcontent",
      };
      temp[1] = {
        name: sdata?.categorydata?.name,
        path: "/uspcontent/viewtopic",
      };
      sdata.breadcrumb = temp;
    }
  }

  function viewtopic(item) {
    let userdata = { ...userDetails };
    userdata.tid = item.id;
    userdata.topic = item.row;
    let temp = userdata.breadcrumb ? [...userdata.breadcrumb] : [];
    temp[0] = {
      name: "USP Content",
      path: "/uspcontent?tab=3",
    };
    temp[1] = {
      name: item.row.tn,
      path: "/uspcontent/viewtopic",
    };

    userdata.breadcrumb = temp;
    dispatch(awsSignIn(userdata));
    navigate("/uspcontent/viewtopic");
  }

  async function getCategories() {
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        action: "get",
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    // setLoading(true);
    try {
      const speakerData = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_CATEGORIES,
        bodyParam,
      );

      // setLoading(false);

      return speakerData.topics;
    } catch (error) {
      //setLoading(false);
      console.error("getUserError", error);
      return [];
    }
  }

  const handleEditClose = () => {
    setEditOpen(false);
  };

  function CustomToolbar() {
    const headers = [
      { label: "Course ID", key: "course_id" },
      { label: "Course Name", key: "coursename" },
      { label: "Course Type", key: "cftype" },
      { label: "Subject", key: "sub" },
      { label: "Speaker Name", key: "speakerName" },
      { label: "Content Added (Yes/No)", key: "contententAdded" },
      { label: "Paid or Free", key: "coursetype" },
      { label: "Course Duration", key: "dur" },
      { label: "Last Modified By", key: "lastmodifiedby" },
      { label: "Last Modified On", key: "lastmodifiedon" },
      { label: "Tags", key: "tags" },
      { label: "Waiting List", key: "waitinglist" },
      { label: "Registered Users", key: "resgisteredusers" },
    ];

    return (
      <GridToolbarContainer
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <Button color="primary">
          <CSVLink
            data={data}
            headers={headers}
            filename={`course-details-${new Date()
              .toLocaleDateString("en-GB")
              .replace(/\//g, "-")}.csv`}
            className={listTopStyle.exp_btn}
          >
            <FileDownload />
            Export
          </CSVLink>
        </Button>
      </GridToolbarContainer>
    );
  }

  useEffect(() => {
    if (speakerList?.length) {
      getTopicList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [speakerList]);

  async function getTopicList() {
    let sdata = { ...userDetails };
    //setLoading(true);

    let catlist = await getCategories();

    console.log("speakerList---", speakerList);
    //const speakerList = speakerList;

    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        tid: sdata?.categorydata?.id,
        admin: true,
        schema: Constants.SCHEMA_NAME,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const list = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_CATEGORY_DATA,
        bodyParam,
      );
      let rows = list.courses.map((item, index) => {
        var obj = {};
        obj.col1 = item.tid;
        obj.id = item.tid;
        obj.course_id =
          item.course_id != null || item?.course_id !== "null"
            ? item?.course_id
            : "";
        obj.tn = item.tn;
        obj.speakerName =
          speakerList
            ?.filter((sp) => item.speakerarray?.includes(sp.sp_id))
            ?.map((sp) => sp.sp_name)
            ?.join(", ") || "";

        obj.coursetype = item.coursetype === "paid" ? "Paid" : "Free";
        obj.dur =
          `${Math.floor(item.dur / 3600) === 0 ? "" : Math.floor(item.dur / 3600) + "h "}` +
          `${Math.floor((item.dur % 3600) / 60)}m ` +
          `${Math.floor(item.dur % 60)}s`;
        obj.cby = item.cby ? item.cby : "Admin";
        obj.con = moment(parseInt(item.mdate)).format("DD-MM-YYYY");

        if (item.mdate === null || item.mdate === undefined) {
          obj.con = moment(parseInt(item.con)).format("DD-MM-YYYY");
        }

        obj.nugcnt = item.nugcnt === 1 ? "Yes" : "No";

        obj.tags = item?.cgry_taggs === undefined ? [] : item?.cgry_taggs;
        obj.waiting = item;
        obj.registered = item;
        obj.publish = item?.tenants?.length;
        obj.tenants = item?.tenants;

        const selectedItem = catlist?.find(
          (item1) => item1.id === item?.cgry_id,
        );

        obj.drafttopics = item?.drafttopics;
        obj.sub = selectedItem?.name;
        obj.cftype =
          item?.cftype === undefined
            ? "-"
            : item?.cftype === 1
              ? "Educational Course"
              : "Non-Educational Course";

        return obj;
      });

      rows.sort((a, b) => {
        const dateA = a.con.split("-").reverse().join("-");
        const dateB = b.con.split("-").reverse().join("-");

        return new Date(dateB) - new Date(dateA);
      });

      rows = rows.filter(
        (obj, index, self) => index === self.findIndex((t) => t.id === obj.id),
      );
      setData(funData(rows));
      //setData1(funData1(list.courses, catlist));
      setTopics(rows);
      //setLoading(false);
      setSpin(false);
    } catch (error) {
      console.error(error);
    }
  }
  async function getAllTenants() {
    //setLoading(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        schema: Constants.SCHEMA_NAME,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const list = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_TENANTS,
        bodyParam,
      );

      setTenants(list.body);
      // setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }
  const tcolumns = [
    {
      field: "col1",
      headerName: "Image",
      headerClassName: `${listTopStyle.superHeader}`,
      flex: 1,
      minWidth: 180,
      disableExport: true,
      renderCell: (params) => (
        <>
          {params.row.drafttopics ? (
            <div
              style={{ position: "relative", width: "130px", height: "80px" }}
            >
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "10px",
                  objectFit: "cover",
                  marginTop: "10px",
                }}
                src={`https://${
                  config.DOMAIN
                }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                  params.value
                }.png`}
                alt=""
              />
              <h2
                style={{
                  position: "absolute",
                  bottom: -10,
                  left: 0,
                  width: "100%",
                  margin: 0,
                  fontSize: "14px",
                  textAlign: "center",
                  backgroundColor: "var(--color-button-background)",
                  color: "white",
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                  padding: "5px 0",
                  lineHeight: "1.2",
                }}
              >
                Draft
              </h2>
            </div>
          ) : (
            <img
              style={{
                width: "130px",
                height: "80px",
                borderRadius: "10px",
                marginTop: "10px",
              }}
              src={`https://${
                config.DOMAIN
              }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                params.value
              }.png`}
              alt=""
            ></img>
          )}
        </>
      ),
    },
    {
      field: "course_id",
      headerName: "Course ID",
      flex: 1,
      minWidth: 180,
      headerClassName: `${listTopStyle.superHeader}`,
    },

    {
      field: "tn",
      headerName: "Course Name",
      flex: 2,
      minWidth: 250,
      headerClassName: `${listTopStyle.superHeader}`,
      renderCell: (params) => (
        <span
          onClick={() => viewtopic(params)}
          style={{
            color: Constants.blue_color,
            textDecoration: "none",
            fontFamily: "14px",
          }}
        >
          {/* {params.value} */}
          <Tooltip title={params.value} placement="top-start">
            <h4
              style={{
                marginTop: "3px",
                fontWeight: "200",

                textTransform: "capitalize",
              }}
            >
              {params.value}
            </h4>
          </Tooltip>
        </span>
      ),
    },
    {
      field: "cftype",
      headerName: "Course Type",
      flex: 1,
      minWidth: 180,
      headerClassName: `${listTopStyle.superHeader}`,
    },

    {
      field: "sub",
      headerName: "Subject",
      flex: 1,
      minWidth: 180,
      headerClassName: `${listTopStyle.superHeader}`,
    },
    {
      field: "cby",
      headerName: "Last Modified By",
      headerClassName: `${listTopStyle.superHeader}`,
      flex: 1,
      minWidth: 200,
    },
    {
      field: "con",
      headerName: "Last Modified On",
      headerClassName: `${listTopStyle.superHeader}`,
      flex: 1,
      minWidth: 220,
    },
    {
      field: "tags",
      headerName: "Tags",
      minWidth: 120,
      flex: 1,
      headerClassName: `${listTopStyle.superHeader}`,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            maxWidth: "190px",
            flexWrap: "wrap",
            gap: "10px",
            marginTop: "40px",
          }}
        >
          {params?.value?.map((item) => (
            <button
              style={{
                maxWidth: "190px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              {item}
            </button>
          ))}
        </div>
      ),
    },
    {
      field: "waiting",
      headerName: "Waiting List",
      flex: 1,
      minWidth: 170,
      headerClassName: `${listTopStyle.superHeader}`,
      renderCell: (param) => (
        <div
          onClick={() => handleWaitingList(param)}
          style={{
            display: "flex",
            width: "50%",
            margin: "0 auto",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          {param.value.waiting_count}
        </div>
      ),
    },
    {
      field: "registered",
      headerName: "Registered Users",
      flex: 1,
      minWidth: 210,
      headerClassName: `${listTopStyle.superHeader}`,
      renderCell: (param) => (
        <div
          onClick={() => handleRegisteredList(param)}
          style={{
            display: "flex",
            width: "50%",
            margin: "0 auto",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          {param.value.registered_count}
        </div>
      ),
    },
    {
      field: "organisation published",
      headerName: "Organisation Published",
      minWidth: 250,
      headerClassName: `${listTopStyle.superHeader}`,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            width: "50%",
            margin: "0 auto",
          }}
        >
          {params.row.tenants.length}
        </div>
      ),
    },
    {
      field: "publish",
      headerName: "Publish",
      disableExport: true,
      headerClassName: `${listTopStyle.superHeader}`,
      minWidth: 140,
      flex: 1,
      renderCell: (params) => {
        const isDraft = !!params?.row?.drafttopics;
        return (
          <div
            style={{
              display: "flex",
              width: "50%",
              marginTop: "20px",
              marginLeft: "26px",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              borderRadius: "1px",
            }}
          >
            {" "}
            {!isDraft && (
              <button
                className={
                  !params?.row?.tenants?.length
                    ? listTopStyle.addbutton
                    : listTopStyle.addbuttongreen
                }
                onClick={() => handlePublishOpen(params)}
              >
                {" "}
                Publish <br /> Unpublish{" "}
              </button>
            )}{" "}
          </div>
        );
      },
    },
  ];

  function handleWaitingList(param) {
    setTopicId(param.value.tid);
    setTopicName(param.value.tn);
    handleWaitOpen();
  }

  function handlePublishOpen(item) {
    setTopicRowData(item.row);
    setEditOpen(true);
  }

  function handleRegOpen() {
    setOpenReg(true);
  }

  function handleRegClose() {
    setOpenReg(false);
  }

  function handleWaitOpen() {
    setOpenWait(true);
  }

  function handleWaitClose() {
    setOpenWait(false);
  }

  function handleRegisteredList(param) {
    setTopicId(param.value.tid);
    handleRegOpen();
  }

  const filterCourses = topics.filter((tabledata) =>
    tabledata?.tn?.toLowerCase().includes(searchText?.toLowerCase()),
  );

  return (
    <div className={listTopStyle.main}>
      <Backdrop
        sx={{ color: "#fff" }}
        open={spin}
        className={listTopStyle.backdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={listTopStyle.modal}
        open={editopen}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <CoursePublish
          handleEditClose={handleEditClose}
          tenants={tenants}
          topicRowData={topicRowData}
          object={false}
          getObjects={getTopicList}
        />
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={listTopStyle.modal}
        open={openReg}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <CourseRegUsers
          topicId={topicId}
          handleRegClose={handleRegClose}
          tenantoid={tenantoid}
          getTopicList={getTopicList}
          listForReg={listForReg}
          topics={topics}
        />
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={listTopStyle.modal}
        open={openWait}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <CourseApproval
          tn={topicName}
          topicId={topicId}
          tenantoid={tenantoid}
          handleWaitClose={handleWaitClose}
          getTopicList={getTopicList}
        />
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={listTopStyle.modal}
        open={open}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <MarkPopularCourse handleClosePopular={close} tabledata={topics} />
      </Modal>
      <div
        style={{ height: 450, width: "100%", overflow: "auto" }}
        className={listTopStyle.root}
      >
        {filterCourses.length <= 0 ? (
          <div
            style={{
              height: "50vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img src={NothiongHereYet} alt="Nothing Here" />
          </div>
        ) : (
          <DataGrid
            rows={filterCourses}
            columns={tcolumns}
            rowHeight={100}
            className={listTopStyle.MuiDataGridRoot}
            slots={{
              toolbar: CustomToolbar,
            }}
            disableSelectionOnClick
          />
        )}
      </div>

      {/* <Button color="primary">
        <CSVLink
          data={data1}
          headers={headers}
          filename="course-details"
          className={listTopStyle.exp_btn}
        >
          <FileDownload />
          Export
        </CSVLink>
      </Button> */}
    </div>
  );
}
